import Component from './component';

Component.defaultProps = {
    visibleMoreCoursesButton: false,
};
export default Component;
